import {h, Fragment} from "preact"
import { useCurrencyFormatting } from '@nosto/preact'
import { hasTagStartingWith, findTagStartingWith } from '../helpers.js'

export default function Prices({ product }) {
    const { format } = useCurrencyFormatting()
    // Check if product has any friends tags
    const hasFriendsTag = hasTagStartingWith(product, '_friends')

    if (hasFriendsTag) {
        // Find the friends tag with price information
        const friendsTag = findTagStartingWith(product, '_friends')
        let friendsPrice = ''

        // Extract price from the tag if found (format: _friends|something|price)
        if (friendsTag) {
            const tagParts = friendsTag.split('|')
            if (tagParts.length >= 3) {
                friendsPrice = tagParts[2]
            }
        }

        return (
            <div class="grid-product__price grid-product__price-friends-price">
                <span class="grid-product__price--regular">{format(product.listPrice)}</span>
                <span class="visually-hidden">Normaali hinta</span>
                <span class="grid-product__price--original"></span>
                <span class="friends-price price--sale">
                    Klubihinta {friendsPrice} €
                </span>
            </div>
        )
    } else if (product.listPrice > product.price) {
        return (
            <div class="grid-product__price">
                <span class="visually-hidden">Ale hinta</span>
                <span class="grid-product__price--regular price--sale">{format(product.price)}</span>
                <span class="visually-hidden">Normaali hinta</span>
                <span class="grid-product__price--original">{format(product.listPrice)}</span>
            </div>
        )
    } else {
        return (
            <div class="grid-product__price">
                <span class="grid-product__price--regular">{format(product.price)}</span>
                <span class="visually-hidden">Regular price</span>
            </div>
        )
    }
}
